export const formatYearsMonthsWeeksDays = (days: number): string => {
  const years: number = Math.floor(days / 365);
  const remainingDaysAfterYears: number = days % 365;
  const months: number = Math.floor(remainingDaysAfterYears / 30);
  const remainingDaysAfterMonths: number = remainingDaysAfterYears % 30;
  const weeks: number = Math.floor(remainingDaysAfterMonths / 7);
  const remainingDays: number = remainingDaysAfterMonths % 7;

  let result: string = '';

  if (years > 0) {
    result += `${years} year${years > 1 ? 's' : ''}`;
  }

  if (months > 0) {
    result += (result ? ' ' : '') + `${months} month${months > 1 ? 's' : ''}`;
  }

  if (weeks > 0) {
    result += (result ? ' ' : '') + `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  if (remainingDays > 0) {
    result +=
      (result ? ' and ' : '') +
      `${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
  }

  return result || `${days} day${days > 1 ? 's' : ''}`;
};
